const form = {
  formId: "new-category-form",
  formField: {
    name: {
      name: "name",
      label: "اسم الفئة",
      type: "text",
      errorMsg: "اسم الفئة مطلوب.",
    },
    description: {
      name: "description",
      label: "وصف الفئة",
      type: "text",
      errorMsg: "الوصف مطلوب.",
    },
  },
};

export default form;
